import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@ls-commons/auth/services';
import { catchError, throwError } from 'rxjs';
import { environment } from '../environments/environment';

const updateUrl = (req: string) => {
  if (req.startsWith('http://') || req.startsWith('https://')) {
    return req;
  }
  for (const [key, value] of Object.entries(environment.urlRestList)) {
    if (req.indexOf(`{${key}}`) > -1) {
      return req.replace(`{${key}}`, `${value}`);
    }
  }

  return environment.urlRestList['DEFAULT'] + req;
};

export const httpInterceptor = (): HttpInterceptorFn => {
  return (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const esNuestraApi =
      req.url.startsWith(environment.urlRestList.API) ||
      !req.url.startsWith('http');

    const urlActualizada = updateUrl(req.url);

    // Clonamos la petición base con las credenciales adecuadas
    let authReq = req.clone({
      url: urlActualizada,
      // Se envían credenciales si es de nuestra API local
      withCredentials: esNuestraApi,
    });

    if (!esNuestraApi) {
      return next(authReq);
    }

    // Añadimos el token si pertenece a nuestra API
    const authService = inject(AuthService);
    const token = authService.getToken();
    if (token) {
      authReq = authReq.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });
    }

    /**
     * Token caducado o invalidado en el servidor: sin esto la SPA seguía
     * navegable pero sin datos. Los endpoints de login gestionan su propio 401.
     */
    const esLogin = req.url.startsWith('usuario/login');
    return next(authReq).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401 && token && !esLogin) {
          authService.logout();
        }
        return throwError(() => err);
      })
    );
  };
};
